import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vModelText as _vModelText, vModelSelect as _vModelSelect, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-00741e63"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box" }
const _hoisted_2 = { class: "tabs" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { class: "has-text-weight-bold" }, "Основная информация", -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { class: "has-text-weight-bold" }, "Паспорт", -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { class: "has-text-weight-bold" }, "Почта", -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { class: "has-text-weight-bold" }, "Контактов в месяц", -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { class: "has-text-weight-bold" }, [
  /*#__PURE__*/_createTextVNode("Копия паспорта"),
  /*#__PURE__*/_createElementVNode("table", { class: "table" })
], -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { class: "content" }
const _hoisted_14 = {
  key: 0,
  class: "table"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "ID", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Телефон", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Ref-метка", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Промокод", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Родитель", -1))
const _hoisted_20 = { key: 0 }
const _hoisted_21 = /*#__PURE__*/_createTextVNode("Перейти в карточку")
const _hoisted_22 = { key: 1 }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Дата регистрации", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Заблокирован", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Удален", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Телефон подтвержден", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Наблюдаемый", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Сотрудник", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, [
  /*#__PURE__*/_createElementVNode("abbr", { title: "Проверено модератором агентской программы" }, "Модерация")
], -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, [
  /*#__PURE__*/_createElementVNode("abbr", { title: "Проверено с помощью API ФНС" }, "Проверено")
], -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "ID менеджера в АМО", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "ID в Казарме", -1))
const _hoisted_33 = { key: 0 }
const _hoisted_34 = ["href", "title"]
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Высокий приоритет", -1))
const _hoisted_36 = { key: 1 }
const _hoisted_37 = { colspan: "2" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_39 = {
  key: 1,
  class: "table"
}
const _hoisted_40 = { colspan: "2" }
const _hoisted_41 = {
  class: "images",
  style: {"width":"100%","height":"556px"}
}
const _hoisted_42 = ["src"]
const _hoisted_43 = {
  key: 2,
  class: "table"
}
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "ИНН", -1))
const _hoisted_45 = { key: 1 }
const _hoisted_46 = {
  key: 2,
  class: "error"
}
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "СНИЛС", -1))
const _hoisted_48 = { key: 1 }
const _hoisted_49 = {
  key: 2,
  class: "error"
}
const _hoisted_50 = { key: 0 }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Дубли по ИНН", -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Фамилия", -1))
const _hoisted_53 = { key: 1 }
const _hoisted_54 = {
  key: 2,
  class: "error"
}
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Имя", -1))
const _hoisted_56 = { key: 1 }
const _hoisted_57 = {
  key: 2,
  class: "error"
}
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Отчество", -1))
const _hoisted_59 = { key: 1 }
const _hoisted_60 = {
  key: 2,
  class: "error"
}
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Пол", -1))
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Тип документа", -1))
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: 1 }, "Паспорт РФ", -1))
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: 0 }, "Не выбрано", -1))
const _hoisted_65 = [
  _hoisted_63,
  _hoisted_64
]
const _hoisted_66 = { key: 1 }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Серия", -1))
const _hoisted_68 = { key: 1 }
const _hoisted_69 = {
  key: 2,
  class: "error"
}
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Номер", -1))
const _hoisted_71 = { key: 1 }
const _hoisted_72 = {
  key: 2,
  class: "error"
}
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Кем выдан", -1))
const _hoisted_74 = { key: 1 }
const _hoisted_75 = {
  key: 2,
  class: "error"
}
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Когда выдан", -1))
const _hoisted_77 = { key: 1 }
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Код подразделения", -1))
const _hoisted_79 = { key: 1 }
const _hoisted_80 = {
  key: 2,
  class: "error"
}
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Место рождения", -1))
const _hoisted_82 = { key: 1 }
const _hoisted_83 = {
  key: 2,
  class: "error"
}
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Гражданство", -1))
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: 1 }, "Россия", -1))
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: 0 }, "Не выбрано", -1))
const _hoisted_87 = [
  _hoisted_85,
  _hoisted_86
]
const _hoisted_88 = { key: 1 }
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Дата рождения", -1))
const _hoisted_90 = { key: 1 }
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Место регистрации", -1))
const _hoisted_92 = { key: 1 }
const _hoisted_93 = { colspan: "2" }
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_95 = {
  key: 3,
  class: "table"
}
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Email", -1))
const _hoisted_97 = { key: 1 }
const _hoisted_98 = {
  key: 2,
  class: "error"
}
const _hoisted_99 = { colspan: "2" }
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_101 = {
  key: 4,
  class: "table"
}
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Максимальное кол-во контактов", -1))
const _hoisted_103 = { key: 1 }
const _hoisted_104 = {
  key: 2,
  class: "error"
}
const _hoisted_105 = { colspan: "2" }
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_BaseCheckbox = _resolveComponent("BaseCheckbox")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _directive_viewer = _resolveDirective("viewer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("ul", null, [
        _createElementVNode("li", {
          class: _normalizeClass({ 'is-active': _ctx.tab === _ctx.tabNames.COMMON }),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.tab = _ctx.tabNames.COMMON))
        }, _hoisted_4, 2),
        _createElementVNode("li", {
          class: _normalizeClass({ 'is-active': _ctx.tab === _ctx.tabNames.PASSPORT }),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.tab = _ctx.tabNames.PASSPORT))
        }, _hoisted_6, 2),
        _createElementVNode("li", {
          class: _normalizeClass({ 'is-active': _ctx.tab === _ctx.tabNames.EMAIL }),
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.tab = _ctx.tabNames.EMAIL))
        }, _hoisted_8, 2),
        _createElementVNode("li", {
          class: _normalizeClass({ 'is-active': _ctx.tab === _ctx.tabNames.MAX_STORE_CONTACTS }),
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.tab = _ctx.tabNames.MAX_STORE_CONTACTS))
        }, _hoisted_10, 2),
        (this.item.entity.passport.page1 || this.item.entity.passport.page2)
          ? (_openBlock(), _createElementBlock("li", {
              key: 0,
              class: _normalizeClass({ 'is-active': _ctx.tab === _ctx.tabNames.PASSPORT_PHOTO }),
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.tab = _ctx.tabNames.PASSPORT_PHOTO))
            }, _hoisted_12, 2))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      (_ctx.tab === _ctx.tabNames.COMMON)
        ? (_openBlock(), _createElementBlock("table", _hoisted_14, [
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _hoisted_15,
                _createElementVNode("td", null, _toDisplayString(_ctx.item.entity.general.id), 1)
              ]),
              _createElementVNode("tr", null, [
                _hoisted_16,
                _createElementVNode("td", null, _toDisplayString(_ctx.item.entity.mlm.phone), 1)
              ]),
              _createElementVNode("tr", null, [
                _hoisted_17,
                _createElementVNode("td", null, _toDisplayString(_ctx.item.entity.mlm.refurl), 1)
              ]),
              _createElementVNode("tr", null, [
                _hoisted_18,
                _createElementVNode("td", null, _toDisplayString(_ctx.item.entity.mlm.promocode), 1)
              ]),
              _createElementVNode("tr", null, [
                _hoisted_19,
                (_ctx.item.entity.general.parent_id)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_20, [
                      _createVNode(_component_router_link, {
                        to: { name: 'AgentsCard', params: { agent: _ctx.item.entity.general.parent_id } }
                      }, {
                        default: _withCtx(() => [
                          _hoisted_21
                        ]),
                        _: 1
                      }, 8, ["to"])
                    ]))
                  : (_openBlock(), _createElementBlock("td", _hoisted_22, "Отсутствует"))
              ]),
              _createElementVNode("tr", null, [
                _hoisted_23,
                _createElementVNode("td", null, _toDisplayString(new Date(_ctx.item.entity.general.registration_date).toLocaleString()), 1)
              ]),
              _createElementVNode("tr", null, [
                _hoisted_24,
                _createElementVNode("td", null, _toDisplayString(_ctx.item.entity.general.is_banned ? 'Да':'Нет'), 1)
              ]),
              _createElementVNode("tr", null, [
                _hoisted_25,
                _createElementVNode("td", null, _toDisplayString(_ctx.item.entity.general.is_deleted ? 'Да':'Нет'), 1)
              ]),
              _createElementVNode("tr", null, [
                _hoisted_26,
                _createElementVNode("td", null, _toDisplayString(_ctx.item.entity.general.is_phone_verified ? 'Да':'Нет'), 1)
              ]),
              _createElementVNode("tr", null, [
                _hoisted_27,
                _createElementVNode("td", null, _toDisplayString(_ctx.item.entity.general.is_watch ? 'Да':'Нет'), 1)
              ]),
              _createElementVNode("tr", null, [
                _hoisted_28,
                _createElementVNode("td", null, _toDisplayString(_ctx.item.entity.general.is_employer ? 'Да':'Нет'), 1)
              ]),
              _createElementVNode("tr", null, [
                _hoisted_29,
                _createElementVNode("td", null, _toDisplayString(_ctx.item.entity.passport.is_passport_verified ? 'Пройдена':'Нет'), 1)
              ]),
              _createElementVNode("tr", null, [
                _hoisted_30,
                _createElementVNode("td", null, _toDisplayString(_ctx.item.entity.passport.is_external_verified ? 'Да':'Нет'), 1)
              ]),
              _createElementVNode("tr", null, [
                _hoisted_31,
                _createElementVNode("td", null, _toDisplayString(_ctx.item.entity.general.amo_manager_id), 1)
              ]),
              _createElementVNode("tr", null, [
                _hoisted_32,
                _createElementVNode("td", null, [
                  (_ctx.item.entity.general.kazarma_data.id==null)
                    ? (_openBlock(), _createElementBlock("b", _hoisted_33, "НЕ заполнено"))
                    : _createCommentVNode("", true),
                  (_ctx.item.entity.general.kazarma_data.id!=null)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 1,
                        href: _ctx.item.entity.general.kazarma_data.link,
                        title: _ctx.item.entity.general.kazarma_data.id
                      }, _toDisplayString(_ctx.item.entity.general.kazarma_data.id), 9, _hoisted_34))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("tr", null, [
                _hoisted_35,
                _createElementVNode("td", null, [
                  (_ctx.editGeneralData)
                    ? (_openBlock(), _createBlock(_component_BaseCheckbox, {
                        key: 0,
                        modelValue: _ctx.item.entity.general.is_high_priority,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.item.entity.general.is_high_priority) = $event)),
                        label: "Да"
                      }, null, 8, ["modelValue"]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_36, _toDisplayString(_ctx.item.entity.general.is_high_priority ? 'Да' : 'Нет'), 1))
                ])
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("td", _hoisted_37, [
                  _hoisted_38,
                  _createElementVNode("div", null, [
                    (_ctx.editGeneralData)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          class: "button is-warning",
                          onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.saveGeneralData && _ctx.saveGeneralData(...args)))
                        }, "Сохранить"))
                      : (_openBlock(), _createElementBlock("a", {
                          key: 1,
                          class: "button is-info",
                          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.editGeneralData = true))
                        }, "Редактировать"))
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.tab === _ctx.tabNames.PASSPORT_PHOTO)
        ? (_openBlock(), _createElementBlock("table", _hoisted_39, [
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("td", _hoisted_40, [
                  _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_41, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.images, (src) => {
                      return (_openBlock(), _createElementBlock("img", {
                        src: `${src}`,
                        style: {"display":"none"}
                      }, null, 8, _hoisted_42))
                    }), 256))
                  ])), [
                    [_directive_viewer, {inline:true,title:false}]
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.tab === _ctx.tabNames.PASSPORT)
        ? (_openBlock(), _createElementBlock("table", _hoisted_43, [
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _hoisted_44,
                _createElementVNode("td", null, [
                  (_ctx.editProfile)
                    ? _withDirectives((_openBlock(), _createElementBlock("input", {
                        key: 0,
                        class: "input",
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.item.entity.passport.inn) = $event))
                      }, null, 512)), [
                        [_vModelText, _ctx.item.entity.passport.inn]
                      ])
                    : (_openBlock(), _createElementBlock("span", _hoisted_45, _toDisplayString(_ctx.item.entity.passport.inn), 1)),
                  (_ctx.innError)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                        _createElementVNode("p", null, _toDisplayString(_ctx.innError), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("tr", null, [
                _hoisted_47,
                _createElementVNode("td", null, [
                  (_ctx.editProfile)
                    ? _withDirectives((_openBlock(), _createElementBlock("input", {
                        key: 0,
                        class: "input",
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.item.entity.passport.snils) = $event))
                      }, null, 512)), [
                        [_vModelText, _ctx.item.entity.passport.snils]
                      ])
                    : (_openBlock(), _createElementBlock("span", _hoisted_48, _toDisplayString(_ctx.item.entity.passport.snils), 1)),
                  (_ctx.snilsError)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                        _createElementVNode("p", null, _toDisplayString(_ctx.snilsError), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              (_ctx.item.entity.passport.doubles && _ctx.item.entity.passport.doubles.length>0)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_50, [
                    _hoisted_51,
                    _createElementVNode("td", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.item.entity.passport.doubles, (double_inn) => {
                        return (_openBlock(), _createElementBlock("p", {
                          key: double_inn.agent_id
                        }, [
                          _createVNode(_component_router_link, {
                            to: { name: 'AgentsCard', params: { agent: double_inn.agent_id } }
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(double_inn.fullname), 1)
                            ]),
                            _: 2
                          }, 1032, ["to"])
                        ]))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("tr", null, [
                _hoisted_52,
                _createElementVNode("td", null, [
                  (_ctx.editProfile)
                    ? _withDirectives((_openBlock(), _createElementBlock("input", {
                        key: 0,
                        class: "input",
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.item.entity.passport.lastname) = $event))
                      }, null, 512)), [
                        [_vModelText, _ctx.item.entity.passport.lastname]
                      ])
                    : (_openBlock(), _createElementBlock("span", _hoisted_53, _toDisplayString(_ctx.item.entity.passport.lastname), 1)),
                  (_ctx.lastnameError)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                        _createElementVNode("p", null, _toDisplayString(_ctx.lastnameError), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("tr", null, [
                _hoisted_55,
                _createElementVNode("td", null, [
                  (_ctx.editProfile)
                    ? _withDirectives((_openBlock(), _createElementBlock("input", {
                        key: 0,
                        class: "input",
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.item.entity.passport.firstname) = $event))
                      }, null, 512)), [
                        [_vModelText, _ctx.item.entity.passport.firstname]
                      ])
                    : (_openBlock(), _createElementBlock("span", _hoisted_56, _toDisplayString(_ctx.item.entity.passport.firstname), 1)),
                  (_ctx.firstNameError)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                        _createElementVNode("p", null, _toDisplayString(_ctx.firstNameError), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("tr", null, [
                _hoisted_58,
                _createElementVNode("td", null, [
                  (_ctx.editProfile)
                    ? _withDirectives((_openBlock(), _createElementBlock("input", {
                        key: 0,
                        class: "input",
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.item.entity.passport.middlename) = $event))
                      }, null, 512)), [
                        [_vModelText, _ctx.item.entity.passport.middlename]
                      ])
                    : (_openBlock(), _createElementBlock("span", _hoisted_59, _toDisplayString(_ctx.item.entity.passport.middlename), 1)),
                  (_ctx.firstNameError)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                        _createElementVNode("p", null, _toDisplayString(_ctx.middleNameError), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("tr", null, [
                _hoisted_61,
                _createElementVNode("td", null, [
                  _createElementVNode("span", {
                    onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.changeSex && _ctx.changeSex(...args))),
                    class: _normalizeClass({'click-changer': _ctx.editProfile})
                  }, _toDisplayString(_ctx.item.entity.passport.male ? 'Мужской':'Женский'), 3)
                ])
              ]),
              _createElementVNode("tr", null, [
                _hoisted_62,
                _createElementVNode("td", null, [
                  (_ctx.editProfile)
                    ? _withDirectives((_openBlock(), _createElementBlock("select", {
                        key: 0,
                        class: "input",
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.item.entity.passport.doctype) = $event))
                      }, _hoisted_65, 512)), [
                        [_vModelSelect, _ctx.item.entity.passport.doctype]
                      ])
                    : (_openBlock(), _createElementBlock("span", _hoisted_66, _toDisplayString(_ctx.item.entity.passport.identity_document), 1))
                ])
              ]),
              _createElementVNode("tr", null, [
                _hoisted_67,
                _createElementVNode("td", null, [
                  (_ctx.editProfile)
                    ? _withDirectives((_openBlock(), _createElementBlock("input", {
                        key: 0,
                        class: "input",
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.item.entity.passport.serial) = $event))
                      }, null, 512)), [
                        [_vModelText, _ctx.item.entity.passport.serial]
                      ])
                    : (_openBlock(), _createElementBlock("span", _hoisted_68, _toDisplayString(_ctx.item.entity.passport.serial), 1)),
                  (_ctx.serialError)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                        _createElementVNode("p", null, _toDisplayString(_ctx.serialError), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("tr", null, [
                _hoisted_70,
                _createElementVNode("td", null, [
                  (_ctx.editProfile)
                    ? _withDirectives((_openBlock(), _createElementBlock("input", {
                        key: 0,
                        class: "input",
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.item.entity.passport.number) = $event))
                      }, null, 512)), [
                        [_vModelText, _ctx.item.entity.passport.number]
                      ])
                    : (_openBlock(), _createElementBlock("span", _hoisted_71, _toDisplayString(_ctx.item.entity.passport.number), 1)),
                  (_ctx.numberError)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                        _createElementVNode("p", null, _toDisplayString(_ctx.numberError), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("tr", null, [
                _hoisted_73,
                _createElementVNode("td", null, [
                  (_ctx.editProfile)
                    ? _withDirectives((_openBlock(), _createElementBlock("input", {
                        key: 0,
                        class: "input",
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.item.entity.passport.who_issued) = $event))
                      }, null, 512)), [
                        [_vModelText, _ctx.item.entity.passport.who_issued]
                      ])
                    : (_openBlock(), _createElementBlock("span", _hoisted_74, _toDisplayString(_ctx.item.entity.passport.who_issued), 1)),
                  (_ctx.issuerError)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                        _createElementVNode("p", null, _toDisplayString(_ctx.issuerError), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("tr", null, [
                _hoisted_76,
                _createElementVNode("td", null, [
                  (_ctx.editProfile)
                    ? (_openBlock(), _createBlock(_component_DatePicker, {
                        key: 0,
                        class: "date",
                        date: _ctx.item.entity.passport.when_issued,
                        onUpdate: _ctx.updatePassportIssueDate
                      }, null, 8, ["date", "onUpdate"]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_77, _toDisplayString(_ctx.item.entity.passport.when_issued ? new Date(_ctx.item.entity.passport.when_issued).toLocaleDateString() : ''), 1))
                ])
              ]),
              _createElementVNode("tr", null, [
                _hoisted_78,
                _createElementVNode("td", null, [
                  (_ctx.editProfile)
                    ? _withDirectives((_openBlock(), _createElementBlock("input", {
                        key: 0,
                        class: "input",
                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.item.entity.passport.unit_code) = $event))
                      }, null, 512)), [
                        [_vModelText, _ctx.item.entity.passport.unit_code]
                      ])
                    : (_openBlock(), _createElementBlock("span", _hoisted_79, _toDisplayString(_ctx.item.entity.passport.unit_code), 1)),
                  (_ctx.unitCodeError)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                        _createElementVNode("p", null, _toDisplayString(_ctx.unitCodeError), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("tr", null, [
                _hoisted_81,
                _createElementVNode("td", null, [
                  (_ctx.editProfile)
                    ? _withDirectives((_openBlock(), _createElementBlock("input", {
                        key: 0,
                        class: "input",
                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.item.entity.passport.place_of_birth) = $event))
                      }, null, 512)), [
                        [_vModelText, _ctx.item.entity.passport.place_of_birth]
                      ])
                    : (_openBlock(), _createElementBlock("span", _hoisted_82, _toDisplayString(_ctx.item.entity.passport.place_of_birth), 1)),
                  (_ctx.placeOfBirthError)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                        _createElementVNode("p", null, _toDisplayString(_ctx.placeOfBirthError), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("tr", null, [
                _hoisted_84,
                _createElementVNode("td", null, [
                  (_ctx.editProfile)
                    ? _withDirectives((_openBlock(), _createElementBlock("select", {
                        key: 0,
                        class: "input",
                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.item.entity.passport.citizenship_id) = $event))
                      }, _hoisted_87, 512)), [
                        [_vModelSelect, _ctx.item.entity.passport.citizenship_id]
                      ])
                    : (_openBlock(), _createElementBlock("span", _hoisted_88, _toDisplayString(_ctx.item.entity.passport.citizenship), 1))
                ])
              ]),
              _createElementVNode("tr", null, [
                _hoisted_89,
                _createElementVNode("td", null, [
                  (_ctx.editProfile)
                    ? (_openBlock(), _createBlock(_component_DatePicker, {
                        key: 0,
                        class: "date",
                        date: _ctx.item.entity.passport.date_birth,
                        onUpdate: _ctx.updatePassportDate
                      }, null, 8, ["date", "onUpdate"]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_90, _toDisplayString(_ctx.item.entity.passport.date_birth ? new Date(_ctx.item.entity.passport.date_birth).toLocaleDateString() : ''), 1))
                ])
              ]),
              _createElementVNode("tr", null, [
                _hoisted_91,
                _createElementVNode("td", null, [
                  (_ctx.editProfile)
                    ? _withDirectives((_openBlock(), _createElementBlock("input", {
                        key: 0,
                        class: "input",
                        "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.item.entity.passport.place_registration) = $event))
                      }, null, 512)), [
                        [_vModelText, _ctx.item.entity.passport.place_registration]
                      ])
                    : (_openBlock(), _createElementBlock("span", _hoisted_92, _toDisplayString(_ctx.item.entity.passport.place_registration), 1))
                ])
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("td", _hoisted_93, [
                  _hoisted_94,
                  _createElementVNode("div", null, [
                    (_ctx.editProfile)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          class: "button is-warning",
                          onClick: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
                        }, "Сохранить"))
                      : (_openBlock(), _createElementBlock("a", {
                          key: 1,
                          class: "button is-info",
                          onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.editProfile = true))
                        }, "Редактировать"))
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.tab === _ctx.tabNames.EMAIL)
        ? (_openBlock(), _createElementBlock("table", _hoisted_95, [
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _hoisted_96,
                _createElementVNode("td", null, [
                  (_ctx.editEmail)
                    ? _withDirectives((_openBlock(), _createElementBlock("input", {
                        key: 0,
                        class: "input",
                        "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.item.entity.general.email) = $event))
                      }, null, 512)), [
                        [_vModelText, _ctx.item.entity.general.email]
                      ])
                    : (_openBlock(), _createElementBlock("span", _hoisted_97, _toDisplayString(_ctx.item.entity.general.email), 1)),
                  (_ctx.emailError)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_98, [
                        _createElementVNode("p", null, _toDisplayString(_ctx.emailError), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("td", _hoisted_99, [
                  _hoisted_100,
                  _createElementVNode("div", null, [
                    (_ctx.editEmail)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          class: "button is-warning",
                          onClick: _cache[25] || (_cache[25] = 
//@ts-ignore
(...args) => (_ctx.saveEmail && _ctx.saveEmail(...args)))
                        }, "Сохранить"))
                      : (_openBlock(), _createElementBlock("a", {
                          key: 1,
                          class: "button is-info",
                          onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.editEmail = true))
                        }, "Редактировать"))
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.tab === _ctx.tabNames.MAX_STORE_CONTACTS)
        ? (_openBlock(), _createElementBlock("table", _hoisted_101, [
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _hoisted_102,
                _createElementVNode("td", null, [
                  (_ctx.editMaxstoreContactInMonth)
                    ? _withDirectives((_openBlock(), _createElementBlock("input", {
                        key: 0,
                        class: "input",
                        "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.item.entity.general.max_store_contacts_in_month) = $event)),
                        type: "number"
                      }, null, 512)), [
                        [_vModelText, _ctx.item.entity.general.max_store_contacts_in_month]
                      ])
                    : (_openBlock(), _createElementBlock("span", _hoisted_103, _toDisplayString(_ctx.item.entity.general.max_store_contacts_in_month), 1)),
                  (_ctx.maxstoreContactInMonthError)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_104, [
                        _createElementVNode("p", null, _toDisplayString(_ctx.maxstoreContactInMonthError), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("td", _hoisted_105, [
                  _hoisted_106,
                  _createElementVNode("div", null, [
                    (_ctx.editMaxstoreContactInMonth)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          class: "button is-warning",
                          onClick: _cache[28] || (_cache[28] = 
//@ts-ignore
(...args) => (_ctx.saveMaxstoreContactInMonth && _ctx.saveMaxstoreContactInMonth(...args)))
                        }, "Сохранить"))
                      : (_openBlock(), _createElementBlock("a", {
                          key: 1,
                          class: "button is-info",
                          onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.editMaxstoreContactInMonth = true))
                        }, "Редактировать"))
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}